/**
 * RYZE THE USER DOCK + THE POLICY SHEET (W-MENU, CC2, 2026-10-18)
 * ============================================================
 * Parent, read-only: SVNTY assets/svnty-drawer.js (section 2 the policy sheet, section 4 the dock
 * count mirror). Loaded (defer) from sections/ryze-header.liquid after ryze-header.js. Leaves THE
 * DRAWER's own machinery (ryze-header.js block 3: one close path, Escape, the Tab trap over burger +
 * drawer, inert while closed) untouched: the dock's links are ordinary focusables inside
 * #ryze-mobile-menu, so the trap already includes them and a tap on one closes the drawer.
 *
 * 1. THE COUNTS: the header is the single source of truth, never a second store. The dock's cart
 *    count (`[data-ryze-udock-count="cart"]`, also `.ryze-mm__badge`, which ryze-custom.js writes
 *    directly) and wishlist count mirror `.ryze-nav__cart-count` / `.ryze-nav__wishlist-count`
 *    (written by ryze-custom.js, ryze-pcard.js, ryze-promo.js, ryze-sticky-atc.js,
 *    ryze-100ml-offer.js, ryze-wishlist.js and the header's inline boot script): the number, the
 *    shown/hidden state, and RYZE's bump (`ryze-badge-bump`, ryze-custom.css) on a real change
 *    after the shared first-second boot window (window.__ryzeBadgeBoot), the writers' own rule.
 * 2. THE POLICY SHEET: the Policies chip toggles `.is-open` on its sheet with aria-expanded; THE
 *    PULL DOWN lands the sheet's last row just above the dock, THE PULL UP returns the reader to
 *    where they were.
 * ============================================================
 */
(function () {
  'use strict';
  /* CODE-26 (2026-10-18): one run per page, whatever loads it twice. */
  if (window.__ryzeUdockInit) return;
  window.__ryzeUdockInit = true;

  /* ── 1. THE COUNTS ─────────────────────────────────────────── */
  function mirror(srcSel, kind) {
    var src = document.querySelector('.ryze-nav ' + srcSel);
    if (!src) return;
    var paint = function () {
      var shown = src.style.display !== 'none';
      var n = (src.textContent || '').trim();
      document.querySelectorAll('[data-ryze-udock-count="' + kind + '"]').forEach(function (b) {
        var moved = b.textContent !== n;
        if (moved) b.textContent = n;
        b.style.display = shown ? '' : 'none';
        window.__ryzeBadgeBoot = window.__ryzeBadgeBoot || Date.now();
        if (moved && shown && Date.now() - window.__ryzeBadgeBoot > 1000) {
          b.classList.remove('ryze-badge-bump');
          void b.offsetWidth;
          b.classList.add('ryze-badge-bump');
        }
      });
    };
    new MutationObserver(paint).observe(src, {
      childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style']
    });
    paint();
  }
  mirror('.ryze-nav__cart-count', 'cart');
  mirror('.ryze-nav__wishlist-count', 'wishlist');

  /* ── 2. THE POLICY SHEET ───────────────────────────────────── */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function dockHeight(sc) {
    var dock = sc && sc.querySelector('.ryze-mm__dock');
    return dock ? dock.getBoundingClientRect().height + 16 : 96;
  }
  document.querySelectorAll('[data-ryze-policies-toggle]').forEach(function (btn) {
    var sheet = document.getElementById(btn.getAttribute('aria-controls'));
    if (!sheet) return;
    var sc = sheet.closest('[data-ryze-scroll]');
    var back = 0;
    btn.addEventListener('click', function () {
      var opening = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (!opening) {
        sheet.classList.remove('is-open');
        if (sc) sc.scrollTo({ top: back, behavior: reduce.matches ? 'auto' : 'smooth' });
        return;
      }
      back = sc ? sc.scrollTop : 0;
      sheet.classList.add('is-open');
      if (!sc) return;
      var landed = false;
      var land = function () {
        if (landed) return;
        landed = true;
        sheet.removeEventListener('transitionend', land);
        if (btn.getAttribute('aria-expanded') !== 'true') return;
        var r = sheet.getBoundingClientRect();
        var sr = sc.getBoundingClientRect();
        var target = sc.scrollTop + (r.bottom - sr.bottom) + dockHeight(sc);
        if (target > sc.scrollTop) sc.scrollTo({ top: target, behavior: reduce.matches ? 'auto' : 'smooth' });
      };
      sheet.addEventListener('transitionend', land);
      window.setTimeout(land, reduce.matches ? 0 : 340);
    });
  });
})();
